import { RouterProvider } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { usePostHog } from '@posthog/react';
import routerRoutes from './config/routes';
import { useGetUserQuery } from './redux/auth/auth.api.slice';
import { setCredentials, setLogout } from './redux/auth/auth.slice';
import { useRecordAuthProvider } from './redux/auth/lastUsedProvider';
import '@/assets/postCommentsTimeline.css';

function App() {
  const dispatch = useDispatch();
  const posthog = usePostHog();
  const { data: user, error, isLoading, isSuccess } = useGetUserQuery();

  useRecordAuthProvider();

  useEffect(() => {
    if (isLoading) return; // Show a loading state if needed

    if (error) {
      dispatch(setLogout()); // Clear any previous credentials if there's an error
      return;
    }
    if (!user && !isLoading) {
      dispatch(setLogout());
      return;
    }
    if (isSuccess) {
      dispatch(setCredentials(user));
      if (import.meta.env.VITE_POSTHOG_PROJECT_TOKEN) {
        posthog.identify(user._id, {
          email: user.email,
          username: user.username,
        });
      }
    }
  }, [user, error, isLoading, dispatch, isSuccess, posthog]);
  return <RouterProvider router={routerRoutes} />;
}

export default App;
